var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 12.2451V21.2451M11.9992 12.2451L9.49923 14.2451M11.9992 12.2451L14.4992 14.2451M5.03323 9.36206C4.08744 9.60005 3.26111 10.1752 2.70948 10.9795C2.15786 11.7838 1.91891 12.7618 2.03754 13.7298C2.15616 14.6979 2.62419 15.5893 3.35369 16.2366C4.0832 16.8839 5.02396 17.2425 5.99923 17.2451H6.99923",
    stroke: "#3876BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8287 7.38308C15.4869 6.02965 14.6433 4.85682 13.4688 4.10234C12.2944 3.34785 10.877 3.06817 9.50395 3.31998C8.13093 3.5718 6.90503 4.33626 6.07476 5.45842C5.24448 6.58057 4.87195 7.97645 5.03269 9.36308C5.03269 9.36308 5.18569 10.2451 5.49869 10.7451",
    stroke: "#3876BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.2451C17.706 17.2446 18.404 17.0946 19.0479 16.805C19.6917 16.5153 20.267 16.0926 20.7357 15.5646C21.2045 15.0366 21.5561 14.4153 21.7674 13.7416C21.9787 13.068 22.045 12.3572 21.9618 11.6561C21.8786 10.9549 21.6479 10.2794 21.2848 9.67386C20.9217 9.06833 20.4345 8.54656 19.8552 8.1429C19.276 7.73924 18.6178 7.46283 17.924 7.33188C17.2302 7.20092 16.5166 7.21838 15.83 7.38312L14.5 7.74512",
    stroke: "#3876BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.1e64cd032da3bb3bf9452df75c4d6be3.svg";
export { ForwardRef as ReactComponent };